import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <>
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                Get to know <strong className="purple">Jeff Akin</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img
                src={laptopImg}
                alt="Shaun K – Senior Data Engineer"
                className="img-fluid"
              />
            </Col>
          </Row>

          <h1 className="project-heading">
            Core <strong className="purple">Technical Skills</strong>
          </h1>
          <Techstack />

          <h1 className="project-heading">
            <strong className="purple">Tools & Platforms</strong> I Work With
          </h1>
          <Toolstack />

          <h1 className="project-heading">
            <strong className="purple">GitHub Insights</strong>
          </h1>
          <Github />
        </Container>
      </Container>
    </>
  );
}

export default About;
